var _defs, _g, _g2, _path, _path2, _circle, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2013.3 331.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #662d91;\n      }\n\n      .st1 {\n        fill: #3a98a9;\n      }\n\n      .st2 {\n        fill: #3f1d58;\n      }\n\n      .st3 {\n        fill: #ef6c26;\n      }\n\n      .st4 {\n        fill: #00434c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "417.5 186.3 523.7 186.3 523.7 150.4 417.5 150.4 417.5 109.2 537.1 109.2 537.1 72.2 376.3 72.2 376.3 268.4 539.1 268.4 539.1 231.4 417.5 231.4 417.5 186.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "794.7 72.2 742.8 72.2 689.8 141.7 632.4 72.2 578.9 72.2 660.4 167.8 577.5 268.4 629.1 268.4 685.3 197.6 744 268.4 797.5 268.4 714.4 171 794.7 72.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M989,80.5c-10.1-5.5-21.3-8.3-33.6-8.3h-108.5v196.2h42v-66.7h62.2c13.3,0,25.2-2.9,35.7-8.7,10.5-5.8,19-13.7,25.4-23.8,6.3-10.1,9.5-21.4,9.5-33.9s-2.9-22.7-8.8-32.2c-5.9-9.5-13.9-17-24-22.6ZM973.1,150c-2.9,4.4-6.8,7.8-11.8,10.2-5,2.4-10.4,3.6-16.4,3.6h-56.6v-53.8h56.6c6,0,11.4,1.1,16.4,3.4,4.9,2.2,8.9,5.2,11.8,9,2.9,3.7,4.3,8.1,4.3,13.2s-1.4,10-4.3,14.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1121.2 72.2 1079.1 72.2 1079.1 268.4 1238.3 268.4 1238.3 230.5 1121.2 230.5 1121.2 72.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1474.3,97.4c-10.4-9.1-22.6-16.3-36.7-21.4-14.1-5.1-29.7-7.7-46.7-7.7s-32.3,2.6-46.4,7.7c-14.1,5.1-26.3,12.3-36.7,21.4-10.4,9.2-18.4,19.9-24.1,32.2-5.7,12.3-8.5,25.7-8.5,40.1s2.8,27.7,8.4,40.1c5.6,12.3,13.6,23.1,24.1,32.2,10.5,9.2,22.7,16.3,36.9,21.4,14.1,5.1,29.7,7.7,46.7,7.7s32.3-2.6,46.4-7.7c14.1-5.1,26.3-12.3,36.7-21.4,10.4-9.1,18.4-19.9,24.1-32.2,5.7-12.3,8.5-25.7,8.5-40.1s-2.9-27.7-8.5-40.1c-5.7-12.3-13.7-23.1-24.1-32.2ZM1458.9,194.1c-3.6,7.5-8.7,14-15.3,19.5-6.5,5.5-14.2,9.9-23.1,13-8.9,3.2-18.7,4.8-29.6,4.8s-20.4-1.6-29.3-4.8c-8.9-3.2-16.6-7.5-23.3-12.9-6.6-5.4-11.7-11.9-15.1-19.5-3.5-7.6-5.2-15.7-5.2-24.5s1.7-17.2,5.2-24.7c3.5-7.5,8.5-13.9,15.1-19.3,6.6-5.4,14.4-9.7,23.3-12.9,8.9-3.2,18.6-4.8,29.3-4.8s20.7,1.6,29.6,4.8c8.9,3.2,16.6,7.5,23.1,13,6.5,5.5,11.6,12,15.3,19.5,3.6,7.5,5.5,15.6,5.5,24.4s-1.8,16.9-5.5,24.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1701.2,190.5c10.6-5.8,19.1-13.5,25.4-23.3,6.3-9.7,9.4-20.7,9.4-33.1s-2.9-22.8-8.7-32.1c-5.8-9.2-13.9-16.5-24.2-21.9-10.4-5.3-22.5-8-36.3-8h-106.5v196.2h40.6v-69.2h47.7l48.4,69.2,49.6.3-52.7-74.8c2.5-1,4.9-2.1,7.3-3.4ZM1688.8,150.8c-2.8,4.4-6.6,7.8-11.3,10.4-4.8,2.5-10,3.8-15.8,3.8h-60.8v-56.3h59.1c6,0,11.5,1.1,16.7,3.4,5.1,2.2,9.1,5.4,12.1,9.5,2.9,4.1,4.3,9,4.3,14.6s-1.4,10.3-4.2,14.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1843 231.4 1843 186.3 1949.2 186.3 1949.2 150.4 1843 150.4 1843 109.2 1962.6 109.2 1962.6 72.2 1801.8 72.2 1801.8 268.4 1964.6 268.4 1964.6 231.4 1843 231.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.5,43.9c-17.7,0-32.1,14.4-32.1,32.1s14.4,32.1,32.1,32.1h20.9V43.9h-20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.4,167.6h0c0,17.7,14.4,32.1,32.1,32.1h20.9v-64.2h-20.9c-17.7,0-32.1,14.4-32.1,32.1Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.4,227.1h-22.2c-17,0-30.8,13.8-30.8,30.8v2.5c0,17,13.8,30.8,30.8,30.8h22.2v-64.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.2,227.1H114.1v64.2h163.1c17,0,30.8-13.8,30.8-30.8v-2.5c0-17-13.8-30.8-30.8-30.8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 275.5,
    cy: 76,
    r: 32.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.7,76c0-17.7-14.4-32.1-32.1-32.1h-75.5v64.2h75.5c17.7,0,32.1-14.4,32.1-32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.8,135.6h-32.7v64.2h32.7c17.7,0,32.1-14.4,32.1-32.1h0c0-17.7-14.4-32.1-32.1-32.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 231.9,
    cy: 167.4,
    r: 32.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreLogo);
export default __webpack_public_path__ + "static/media/explore-logo.4d5f4f7cff1caf5d181b4b2c67684bda.svg";
export { ForwardRef as ReactComponent };